import React from 'react';
import '../components/Polymathy.css';

const GRCServicesPage = () => {
  const grcServices = [
    {
      area: 'Board and Executive Strategic Advisory Services',
      description: 'We enhance the effectiveness of your Board and executive team by advising on best practices for corporate governance, organizational design, and critical decision frameworks, ensuring alignment between strategy and execution.'
    },
    {
      area: 'Integrated GRC Architecture Services',
      description: 'We help you integrate GRC technologies and processes across the organization, optimizing your internal controls and establishing a robust architecture for proactive risk identification and compliance monitoring.'
    },
    {
      area: 'Independent Audit and Assurance Services',
      description: [
        'We provide independent, objective financial statement audits that enhance the credibility and transparency of your reported financial information, building essential trust with investors, lenders, and regulators.',
        'Establish or transform IA functions using risk-based, tech-enabled approaches (e.g., Arbutus, AutoAudit). Deliver high-value, objective assurance across the enterprise.'
      ]
    },
    {
      area: 'Business Excellence and Continuous Improvement',
      description: [
        'We analyze end-to-end business processes, identifying bottlenecks and areas for strategic redesign. Our goal is to achieve a step-change in performance by streamlining workflows and making quality an inherent part of your operations.',
        'Lead operational efficiency initiatives through process walkthroughs, mapping, and policy standardization. Focus on eliminating waste and ensuring sustainable compliance.'
      ]
    },
    {
      area: 'Integrated Policy and Control Framework Services',
      description: [
        'We design and implement a single, cohesive framework for all your corporate policies, operational procedures, and internal controls, guaranteeing consistency, reducing compliance gaps, and simplifying management oversight.',
        'Architect and embed control frameworks, standardize procedures, and documentation across multi-geographic entities. Conduct walkthroughs, mapping, and redesign to eliminate waste and reduce variation.'
      ]
    },
    {
      area: 'Enterprise Internal Control Management Solutions',
      description: 'We help you shift from reactive controls to a proactive, risk-based system. This involves mapping critical business risks to specific controls, enabling management to focus resources where they matter most for enterprise protection.'
    },
    {
      area: 'Fraud Risk Management and Forensic Investigation Services',
      description: 'We design and implement robust, proactive fraud risk management programs and internal controls to safeguard assets, minimize exposure, and build a culture of integrity across your organization.'
    },
    {
      area: 'Cybersecurity and IT Governance Advisory',
      description: 'We provide C-suite and Board-level advisory to establish robust IT governance frameworks and implement strategies that build organizational cyber resilience, ensuring digital assets are protected and risks are strategically managed.'
    },
    {
      area: 'Leadership & Talent Development Programs',
      description: 'We design and deliver customized mentoring and training programs to build leadership capacity, enhance critical skills across your staff, and ensure your teams are prepared for future strategic challenges.'
    }
  ];

  return (
    <section className="polymathy-section">
      <div className="container">
        <div className="polymathy-header">
          <h2 className="section-title center">GOVERNANCE, RISK & COMPLIANCE (GRC)</h2>
          <div className="title-underline center"></div>
          <p className="polymathy-subtitle">
            Strategic Advisory Services
          </p>
        </div>

        <div className="services-section">
          <div className="service-category-section">
            <div className="services-table">
              <div className="services-header">
                <span>Service Area</span>
                <span>Description</span>
              </div>
              {grcServices.map((service) => (
                <div key={service.area} className="service-row">
                  <div className="service-area">{service.area}</div>
                  <div className="service-description">
                    {Array.isArray(service.description) ? (
                      service.description.map((paragraph, paragraphIndex) => (
                        <p key={paragraphIndex}>{paragraph}</p>
                      ))
                    ) : (
                      <p>{service.description}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GRCServicesPage;

